// extracted by mini-css-extract-plugin
export default {"chartFilter":"app-options_chartFilter__NmbnW","filterDot":"app-options_filterDot__6G-qe"};